<template>
  <div class="">
    <navigation/>
    <!--Banner Wrap Start-->
    <div class="iner_banner" style="margin-bottom: 50px">
      <div class="container">
        <h5>Applications</h5>
        <div class="banner_iner_capstion">
          <ul>
            <li>
              <router-link to="/">Home</router-link>
            </li>
            <li>
              <router-link to="/about">Apply.</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container" id="big">
      <!-- <h4 class="text-center text-danger" style="color:#C9A63C">APPLICATION FORM</h4> -->
      <!-- Material form row -->
      <form @submit.prevent="addData()">
        <!-- Grid row -->
        <div class="container">
          <div class="form-row" id="due">
            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="destination" class="text-left">DESTINATION</label>
                <input type="text" class="form-control" required v-model="destination">
              </div>
            </div>
            <!-- Grid column -->

            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6 ">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="purpose" class="text-left">PURPOSE</label>
                <input type="text" class="form-control" required v-model="purpose">
              </div>
            </div>
            <!-- Grid column -->
          </div>
        </div>
        <!-- Grid row -->
      </form>
      <!-- Material form row -->
      <form @submit.prevent="addData()">
        <!-- Grid row -->
        <div class="container">
          <div class="form-row" id="due">
            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="title" class="text-left">TITLE</label>
                <select class="form-control" required v-model="title">
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                </select>
              </div>
            </div>
            <!-- Grid column -->

            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6 ">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="email" class="text-left">E-MAIL</label>
                <input type="email" class="form-control" required v-model="email">
              </div>
            </div>
            <!-- Grid column -->
          </div>
        </div>
        <!-- Grid row -->
      </form>
      <!-- Material form row -->
      <form @submit.prevent="addData()">
        <!-- Grid row -->
        <div class="container">
          <div class="form-row" id="due">
            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="first" class="text-left">FIRST NAME</label>
                <input type="text" class="form-control" required v-model="name">
              </div>
            </div>
            <!-- Grid column -->

            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6 ">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="surname" class="text-left">SURNAME</label>
                <input type="text" class="form-control" required v-model="surname">
              </div>
            </div>
            <!-- Grid column -->
          </div>
        </div>
        <!-- Grid row -->
      </form>
      <form @submit.prevent="addData()">
        <!-- Grid row -->
        <div class="container">
          <div class="form-row" id="due">
            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="number" class="text-left">PHONE NUMBER</label>
                <input type="number" class="form-control" required v-model="number">
              </div>
            </div>
            <!-- Grid column -->

            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6 ">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="date" class="text-left">DATE OF BIRTH</label>
                <input type="date" class="form-control" required v-model="birth">
              </div>
            </div>
            <!-- Grid column -->
          </div>
        </div>
        <!-- Grid row -->
      </form>
      <form @submit.prevent="addData()">
        <!-- Grid row -->
        <div class="container">
          <div class="form-row" id="due">
            <!-- Grid column -->
            <!--                        <div class="col-12 col-md-12 col-lg-6">-->
            <!--                            &lt;!&ndash; Material input &ndash;&gt;-->
            <!--                            <div class="md-form mt-0">-->
            <!--                                <label for="email" class="text-left"> WORK EXPERIENCE</label>-->
            <!--                                <textarea v-model="experience" rows="5" class="form-control"></textarea>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!-- Grid column -->
            <div class="col-12 col-md-12 col-lg-6">
              <!-- Material input -->
              <div class="md-form mt-0">
                <label for="email" class="text-left">HIGHEST QUALIFICATION</label>
                <select class="form-control-lg" v-model="education">
                  <option value="High School Diploma">High School Diploma</option>
                  <option value="Undergraduate">Undergraduate</option>
                  <option value="Postgraduate">Postgraduate</option>
                  <option value="Master">Master</option>
                  <option value="Others">Others</option>
                </select>
              </div>
            </div>
            <!-- Grid column -->


          </div>
        </div>

        <!-- Grid row -->
      </form>
      <div class="iq-input">
        <router-link to="/"><input type="button" value="SUBMIT" @click="addData()"
                                   style="background-color:#c9a63c; padding:15px;margin-top: 20px"></router-link>
      </div>
    </div>
    <footers/>
  </div>
</template>

<script>
import {firestoreTimeStamp, firestoreDB} from './firebase.js'
import navigation from './navigation.vue'
import footers from './footer.vue'


export default {
  name: 'Application',
  components: {navigation, footers},
  data() {
    return {
      destination: sessionStorage.getItem("destination"),
      purpose: sessionStorage.getItem("purpose"),
      title: " ",
      email: " ",
      name: " ",
      surname: " ",
      number: " ",
      birth: " ",
      experience: " ",
      education: " ",
    }
  },
  methods: {
    addData() {
      const ref = firestoreDB.collection('application');
      ref.add({
        //  timestamp: FieldValue.serverTimestamp(),
        dateCreated: firestoreTimeStamp,
        destination: this.destination,
        purpose: this.purpose,
        title: this.title,
        email: this.email,
        name: this.name,
        surname: this.surname,
        number: this.number,
        birth: this.birth,
        experience: this.experience,
        education: this.education,
      }).then(() => {
        alert("APPLICATION SUBMITTED")
      });
    }
  }

};
// var timestamp= firebase.firestore.FieldValue.serverTimestamp();
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.categries-list li:before {
  float: left;
  content: "\f192";
  color: #c9a63c !important;
  margin: 0 15px 0 0;
  color: currentColor;
  font-family: "FontAwesome";
}

.categries-list {
  color: #777777
}

.iq_best_knowledge_bg {
  background-image: url(../assets/extra-images/about_banner.jpg);
}

@media (max-width: 767px) {
  .iq_best_knowledge_bg {
    background-image: none;
    text-align: center;
  }
}

.panel-heading:hover a, .panel-heading:focus a {
  color: #c9a63c;
}

.employees {
  /* height: 20%; */
}

.iq_heading_1 h4:before {
  background-color: #c9a63c
}

a[aria-expanded=true] .fa-chevron-right {
  display: none;
}

a[aria-expanded=false] .fa-chevron-down {
  display: none;
}

.fa-chevron-right, .fa-chevron-down {
  color: #c9a63c;
  margin-top: 10px
}

/* .fa-caret-down option{
    color: #fff !important;
} */
.form-control {
  display: block;
  width: 100%;
  padding: .375rem .75rem;
  font-size: 17px;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 2px solid #ced4da;
  border-radius: .35rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  margin-bottom: 10px;
  margin-top: 10px;
}

#big {
  /* border: 1px solid #ced4da; */
  /* background-color: #ced4da; */
  /* background-color:rgb(248, 229, 176); */
  margin-top: 25px;
  margin-bottom: 25px;
  padding-bottom: 20px;
  padding-top: 20px;
}

.text-left {
  font-size: 15px;
  font-weight: 600;
  margin-top: 20px;
}

label {
  color: #c9a63c;
}
</style>
